export default __webpack_public_path__ + "static/media/remove.1e7a0a04.svg";